/**
 * Display prices without useless decimals (250 not 250.00). Keeps real fractions (199.5).
 * @param {unknown} value
 * @returns {string}
 */
export function formatPriceDisplay(value) {
  if (value === null || value === undefined || value === '') return '0'
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, ''))
  if (Number.isNaN(n)) return String(value)
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 10,
    minimumFractionDigits: 0,
  }).format(n)
}
